module.exports = __webpack_public_path__ + "img/fitness1.15cf8db1.png";